/* global swal, _, angular*/
import './style.less';
import { findLastIndex, groupBy } from 'lodash';

export default function($log, CategoryClass) {
  'ngInject';

  const vm = this;
  vm.$onInit = activate;

  /**
   * Takes an array of strings or objects with a name prop, and puts a
   * separator between all the names, and an additional separator before the last one.
   *
   * @param {*} arr
   * @param {*} and
   * @param {*} separator
   */
  function separatorList(arr = [], separator = ', ', and = 'and ') {
    return arr.reduce((acc, obj, index) => {
      const str = typeof obj === 'string' ? obj : obj.basic_name || obj.name;

      return str
        ? `${acc}${acc && index > 0 ? separator : ''}${
            acc && and && index > 0 && index === arr.length - 1 ? and : ''
          }${str}`
        : acc;
    }, '');
  }

  /**
   * Builds out a description of a profile
   *
   * @param {*} certProfile
   */
  function getProfileDescription(certProfile) {
    if (!certProfile) {
      return;
    }

    const { levels, user_locations, departments, practice_areas, regulators } = certProfile;

    const name = `${certProfile.first} ${certProfile.last}`;
    const levels_list = separatorList(levels);
    const locations_list = separatorList(user_locations, ' | ', '');
    const line_1 = separatorList([name, levels_list, locations_list], ' | ', '');
    const desc = [line_1];

    const departments_list = separatorList(departments);
    const practice_areas_list = separatorList(practice_areas);
    const regulators_list = separatorList(regulators);
    const line_2 = separatorList([departments_list, practice_areas_list, regulators_list], ' | ', '');
    line_2 && desc.push(line_2);

    return desc;
  }

  function activate() {
    $log.debug('Add Hour Component Activated');

    vm.profileDescription = getProfileDescription(vm.certProfile);

    vm.ngModel = vm.ngModel || [{}];

    let ngModelTemp = angular.copy(vm.ngModel);

    vm.$doCheck = () => {
      if (vm.ngModel && Array.isArray(vm.ngModel) && !angular.equals(vm.ngModel, ngModelTemp)) {
        vm.ngModel.forEach(hour => {
          if (!hour.subject_area || !hour.subject_area.length || !hour.category_id || !hour.category_id.length) {
            delete hour.subject_area;
            delete hour.category_id;
          }
        });
        ngModelTemp = angular.copy(vm.ngModel);
        vm.ngChange();
      }
    };

    vm.updateHours = () => {
      vm.ngModel.forEach(hour => {
        if (hour && hour.category_id && vm.categoryDict[hour.category_id]) {
          hour.subject_area = vm.categoryDict[hour.category_id].name;
        }
      });
    };

    vm.showAdd = () => !vm.ngModel || !vm.ngModel.filter(({ prep }) => prep === vm.prep).length;

    vm.lastIndex = () => findLastIndex(vm.ngModel, hour => hour.prep == vm.prep);

    CategoryClass.loadCategories()
      .then(({ arr, obj }) => {
        vm.categories = arr;
        vm.categoryGroups = groupBy(arr, 'industry');
        vm.categoryDict = obj;
      })
      .catch(error => {
        $log.error(error);
        throw error;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/forms/hours/controller.js